import { niceApi } from '@/plugins/api/niceApi'

export default {
  name: 'nice',
  namespaced: true,
  actions: {
    async addUser({}, user) {
      const { data } = await niceApi.postUsers(user)
      return data
    },
  },
}
